import React from 'react';
import PropTypes from 'prop-types';
import xss from 'xss';
import HtmlToReact from 'html-to-react';
// props is below:
// title:
// subtitle:
// paragraphs: [p1, p2, p3]
// moreInfoLink
// moreInfoText

// create a stateless react component
let htmlToReactParser = new HtmlToReact.Parser(React);

export default function ShowInfo(props) {
  let paragraphs = props.paragraphs || [];
  return (
    <div className="ui segment ignored info attached borderless bg-transparent " style={{ top: '4px' }}>
      <p>
        {props.noIcon ? '' : <i className="ui icon info circle mrrnull pdrxs text-size-xxl span-like" />}
        <span style={{ paddingTop: '1px' }} className="color-info bold text-size-mml">
          {props.title}
          <span className="color-info normal text-size-m" data-show={props.subtitle != undefined}>
            {htmlToReactParser.parse(xss(props.subtitle))}
          </span>
        </span>
        {paragraphs.map((paragraph, index) => (
          <span key={index} className={`color-info mrts ${props.paraClassName}`}>
            {htmlToReactParser.parse(paragraph)}
          </span>
        ))}
        {!window.hideUnfinishedItems ? (
          <a className="mrtm mrbm" target="_blank" href={props.moreInfoLink}>
            {props.moreInfoText || 'More information '}
          </a>
        ) : (
          ''
        )}
      </p>
    </div>
  );
}

ShowInfo.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  paragraphs: PropTypes.array,
  moreInfoLink: PropTypes.string,
  moreInfoText: PropTypes.string,
};
